import { Exclude } from 'class-transformer';
import {
  IFixIntervalViewType,
  IVariableIntervalViewType,
} from '../../../features/calendar/components/time-block/types/time-block-types';
import { TimeBlockGeometryData } from './time-block-geometry-data.model';

// A fix interval is either a full day, or half day time block.
// A variable interval is a timeBlock with variable start and end times.
export class TimeBlockDayOrWeekVariableIntervalType implements IVariableIntervalViewType {
  @Exclude()
  public laneIndex = -1; // Lane index of the current selected part. lanes outside of view included (i.e. invisibleLaneIndex)

  @Exclude()
  public geometryData: TimeBlockGeometryData | null = null;
}

export class TimeBlockDayOrWeekFixIntervalType implements IFixIntervalViewType {
  @Exclude()
  public laneIndexStart = -1; // Lane index of the most left part. Lanes outside of view included (i.e. invisibleLaneIndex)

  @Exclude()
  public laneIndexEnd = -1; // Lane index of the most right part. Lanes outside of view included (i.e. invisibleLaneIndex)

  @Exclude()
  public geometryData: TimeBlockGeometryData | null = null;

  @Exclude()
  public parallelIndex = -1;
}

export class TimeBlockMonthVariableIntervalType implements IVariableIntervalViewType {
  @Exclude()
  public laneIndex = -1;

  @Exclude()
  public offsetStartDate = null;

  @Exclude()
  public geometryData: TimeBlockGeometryData | null = null;

  @Exclude()
  public parallelIndex = -1;
}

export class TimeBlockMonthFixIntervalType implements IFixIntervalViewType {
  @Exclude()
  public laneIndexStart = -1; // A lane corresponds to a cell in the month view

  @Exclude()
  public laneIndexEnd = -1; // A lane corresponds to a cell in the month view

  @Exclude()
  public geometryData: TimeBlockGeometryData | null = null;

  @Exclude()
  public parallelIndex = -1;
}

export class TimeBlockGenericVariableIntervalType implements IVariableIntervalViewType {
  @Exclude()
  public laneIndex = -1;

  @Exclude()
  public offsetStartDate = null;

  @Exclude()
  public geometryData: TimeBlockGeometryData | null = null;

  @Exclude()
  public parallelIndex = -1;
}

export class TimeBlockGenericFixIntervalType implements IFixIntervalViewType {
  @Exclude()
  public laneIndexStart = -1; // A lane corresponds to a cell in the month view

  @Exclude()
  public laneIndexEnd = -1; // A lane corresponds to a cell in the month view

  @Exclude()
  public geometryData: TimeBlockGeometryData | null = null;

  @Exclude()
  public parallelIndex = -1;
}
